import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=507fe16a&scoped=true&"
import script from "./PdfView.vue?vue&type=script&lang=ts&"
export * from "./PdfView.vue?vue&type=script&lang=ts&"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=507fe16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fe16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VFlex,VLayout,VProgressCircular})
